module.exports = __webpack_public_path__ + "img/Halbzeit.5531a2cd.jpg";